import { render, staticRenderFns } from "./ProductTechnicalFilters.vue?vue&type=template&id=22b54ec7"
import script from "./ProductTechnicalFilters.vue?vue&type=script&lang=js"
export * from "./ProductTechnicalFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductTechnicalFilters.vue?vue&type=style&index=0&id=22b54ec7&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ColorTemperatureHelp: require('/app/components/ColorTemperatureHelp.vue').default,TechnicalFilterHelp: require('/app/components/TechnicalFilterHelp.vue').default,ProductTechnicalFilterRange: require('/app/components/ProductTechnicalFilterRange.vue').default,ProductTechnicalFilterChipLabel: require('/app/components/ProductTechnicalFilterChipLabel.vue').default,ProductTechnicalFilterPanel: require('/app/components/ProductTechnicalFilterPanel.vue').default,BottomSheet: require('/app/components/BottomSheet.vue').default})
